/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type MultipleChoiceExerciseAnalysis_exercise = {
    readonly content: {
        readonly prompt: string;
        readonly choices: ReadonlyArray<{
            readonly isCorrect: boolean;
            readonly text: string;
        }>;
    };
    readonly " $refType": "MultipleChoiceExerciseAnalysis_exercise";
};
export type MultipleChoiceExerciseAnalysis_exercise$data = MultipleChoiceExerciseAnalysis_exercise;
export type MultipleChoiceExerciseAnalysis_exercise$key = {
    readonly " $data"?: MultipleChoiceExerciseAnalysis_exercise$data;
    readonly " $fragmentRefs": FragmentRefs<"MultipleChoiceExerciseAnalysis_exercise">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "MultipleChoiceExerciseAnalysis_exercise",
  "type": "MultipleChoiceExercise",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "content",
      "storageKey": null,
      "args": null,
      "concreteType": "MultipleChoiceExerciseContent",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "prompt",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "choices",
          "storageKey": null,
          "args": null,
          "concreteType": "MultipleChoiceExerciseChoice",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "isCorrect",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "text",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    }
  ]
};
(node as any).hash = 'e68b76607ad41585c2e8eb0a2e82ced2';
export default node;
